import React, {useEffect, useState} from "react";
import { GetCanendar, UpdateDailyCheck, UpdateTodoList } from "./api";
import './home.scss';
import MCalendar from "./tools/mCalendar";
import MJourney from "./tools/mJourney";
import SDCheck from "./tools/sdCheck";

function Home (props) {
    const [memo, setMemo] = useState([]);
    const [finance, setFinance] = useState([]);
    const [memorial, setMemorial] = useState([]);
    const [todoList, setTodoList] = useState([]);
    const [dailyCheck, setDailyCheck] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());
    const [day, setDay] = useState(new Date().getDate());
    const [dayMemo, setDayMemo] = useState({});
    const [userMC, setUserMC] = useState({
        target: [],
        warning: [],
    });

    const [mcHistory, setMCHistory] = useState([]);

    useEffect(() => {
        CheckMemo();
    }, [memo, year, month, day]);

    function selectDay (e, d) {
        setYear(d.year);
        setMonth(d.month);
        setDay(d.day);
    }

    useEffect(() => {
        let token = JSON.parse(localStorage.getItem('token'));
        
        if (!token) return;
        
        GetCanendar().then(res => {
            setMemo(res.data.journey);
            setFinance(res.data.finance);
            setMemorial(res.data.memorial);
            setTodoList(res.data.todoList);
            setDailyCheck(res.data.dailyChecked);
            setUserMC(res.data.userMC);
            setMCHistory(res.data.userMCHistory);
        })

    }, [])

    function CheckMemo () {
        let tdm = memo.filter(m => m.startYear === year && m.startMonth === month && m.startDay === day);
        setDayMemo(tdm);
    }

    function CheckTodo (d, b) {
        UpdateTodoList({
            "TodoID": d.todoID,
            "Year": d.year,
            "Month": d.month,
            "Day": d.day,
            "Title": d.title,
            "Checked": b
        }).then(res => {
            console.log(res);
        });
    }

    function CheckDaily (d, b) {
        let data = {
            DailyCheckedID: d.dailyCheckedID, 
            Checked: b
        }

        UpdateDailyCheck(data).then(res => {
        })
    }

    return (
        <div className="homepage">
            <div className="tip">
            {
                todoList.map(td => {
                    let limit = td.limit > 0 ? '剩' : '逾期'
                    return <SDCheck value={td.checked} label={`${td.title}-${limit}${td.limit}天`} type="todo" key={td.todoID}
                    data={td} changeState={(d, b) => CheckTodo(d, b)}></SDCheck>
                })
            }
            <div className="dailyTitle">每日確認事項</div>
            {
                dailyCheck.map(dc => {
                    return <SDCheck value={dc.checked} label={`${dc.subTitle}`} type="todo" key={dc.dailyCheckedID}
                    data={dc} changeState={(d, b) => CheckDaily(d, b)}></SDCheck>
                })
            }
            </div>
            <div className="calendar">
                <MCalendar selectDay={selectDay}
                memo={memo} finance={finance} userMC={userMC}
                memorial={memorial} todoList={todoList} mcHistory={mcHistory}
                ></MCalendar>
            </div>
            <div className="rightBlock">
                <div className="dayBlock">
                    <div className="journey">
                    <MJourney year={year} month={month + 1} day={day}
                    journey={dayMemo}></MJourney>
                    </div>
                </div>
            </div>
        </div>
    )    
}

export default Home;